module.exports = __webpack_public_path__ + "img/voting.8e235bea.svg";